'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.default = wiki;

var _util = require('./util'),
    _page = require('./page'),
    _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var defaultOptions = {
  apiUrl: 'http://en.wikipedia.org/w/api.php',
  origin: '*'
};

function wiki() {
  function a(n) {
    return n.query.redirects && 1 === n.query.redirects.length ? (0, _util.api)(m, {
      prop: 'info|pageprops',
      inprop: 'url',
      ppprop: 'disambiguation',
      titles: n.query.redirects[0].to
    }) : n;
  }

  function b(n) {
    var o = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 50;
    return (0, _util.pagination)(m, {
      list: 'search',
      srsearch: n,
      srlimit: o
    }, function (p) {
      return p.query.search.map(function (q) {
        return q.title;
      });
    }).catch(function (p) {
      if ('"text" search is disabled.' === p.message) return c(n, o);
      throw p;
    });
  }

  function c(n) {
    var o = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 50;
    return (0, _util.api)(m, {
      search: n,
      limit: o,
      namespace: 0,
      action: 'opensearch',
      redirects: void 0
    }).then(function (p) {
      return p[1];
    });
  }

  function e(n) {
    return (0, _util.api)(m, {
      prop: 'info|pageprops',
      inprop: 'url',
      ppprop: 'disambiguation',
      titles: n
    }).then(a).then(function (o) {
      var p = Object.keys(o.query.pages)[0];
      if (!p || '-1' === p) throw new Error('No article found');
      return (0, _page2.default)(o.query.pages[p], m);
    });
  }

  var l = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
  this instanceof wiki && console.log('Please do not use wikijs ^1.0.0 as a class. Please see the new README.');
  var m = Object.assign({}, defaultOptions, l);
  return {
    search: b,
    random: function random() {
      var n = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : 1;
      return (0, _util.api)(m, {
        list: 'random',
        rnnamespace: 0,
        rnlimit: n
      }).then(function (o) {
        return o.query.random.map(function (p) {
          return p.title;
        });
      });
    },
    page: e,
    geoSearch: function geoSearch(n, o) {
      var p = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : 1e3;
      return (0, _util.api)(m, {
        list: 'geosearch',
        gsradius: p,
        gscoord: n + '|' + o
      }).then(function (q) {
        return q.query.geosearch.map(function (r) {
          return r.title;
        });
      });
    },
    options: l,
    findById: function findById(n) {
      return (0, _util.api)(m, {
        prop: 'info|pageprops',
        inprop: 'url',
        ppprop: 'disambiguation',
        pageids: n
      }).then(a).then(function (o) {
        var p = Object.keys(o.query.pages)[0];
        if (!p || '-1' === p) throw new Error('No article found');
        return (0, _page2.default)(o.query.pages[p], m);
      });
    },
    find: function find(n) {
      var o = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : function (p) {
        return p[0];
      };
      return b(n).then(function (p) {
        return o(p.results);
      }).then(function (p) {
        return e(p);
      });
    },
    allPages: function allPages() {
      return (0, _util.aggregate)(m, {}, 'allpages', 'title', 'ap');
    },
    allCategories: function allCategories() {
      return (0, _util.aggregate)(m, {}, 'allcategories', '*', 'ac');
    },
    pagesInCategory: function pagesInCategory(n) {
      return (0, _util.aggregate)(m, {
        cmtitle: n
      }, 'categorymembers', 'title', 'cm');
    },
    opensearch: c
  };
}